export const PaymentLimitStyles = () => {
  return {
    wrapper: {
      padding: "60px 0 !important",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    content: {
      info: {
        maxWidth: "60%",
        textAlign: "center",
      },
    },
  };
};
